export const RecruiterContributionByStatus = ({
  primaryColor = '#ffd800',
  primaryFontColor = 'rgba(0,0,0,0.8)',
}) => {
  return (
    <svg width="606.289" height="337.46" viewBox="0 0 606.289 337.46">
      <defs>
        <filter
          id="Rectangle_20353"
          x="0"
          y="0"
          width="606.289"
          height="337.46"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Group_42269"
        data-name="Group 42269"
        transform="translate(-16060.199 -15951.938)"
      >
        <g
          id="Group_42178"
          data-name="Group 42178"
          transform="translate(16069.199 15954.851)"
        >
          <g
            transform="matrix(1, 0, 0, 1, -9, -2.91)"
            filter="url(#Rectangle_20353)"
          >
            <rect
              id="Rectangle_20353-2"
              data-name="Rectangle 20353"
              width="588.29"
              height="319.46"
              rx="20"
              transform="translate(9 6)"
              fill="#fff"
            />
          </g>
          <path
            id="Union_65"
            data-name="Union 65"
            d="M326.235,37.655H0V19A19,19,0,0,1,19,0H415.2L390.38,37.655Z"
            transform="translate(0 0)"
            fill={primaryColor}
          />
          <text
            id="Recruiter_Contribution_by_Status"
            data-name="Recruiter Contribution by Status"
            transform="translate(15.815 23.939)"
            fill={primaryFontColor}
            font-size="13"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0">
              Recruiter's Contribution by Status
            </tspan>
          </text>
          <line
            id="Line_439"
            data-name="Line 439"
            y2="223.668"
            transform="translate(90.999 58.514)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_440"
            data-name="Line 440"
            x2="551.262"
            transform="translate(18.702 87.884)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_435"
            data-name="Line 435"
            x2="551.262"
            transform="translate(18.702 193.317)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_438"
            data-name="Line 438"
            x2="551.262"
            transform="translate(18.326 122.903)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_436"
            data-name="Line 436"
            x2="551.262"
            transform="translate(18.702 228.712)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_437"
            data-name="Line 437"
            x2="551.262"
            transform="translate(16.443 158.675)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_434"
            data-name="Line 434"
            x2="551.262"
            transform="translate(19.079 263.354)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <text
            id="Sandeep_Kaur"
            data-name="Sandeep Kaur"
            transform="translate(19.079 78.94)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Sandeep Kaur
            </tspan>
          </text>
          <text
            id="Chaithanya_Katta"
            data-name="Chaithanya Katta"
            transform="translate(19.079 149.224)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Chaithanya Katta
            </tspan>
          </text>
          <text
            id="Derek_Zachary"
            data-name="Derek Zachary"
            transform="translate(18.702 115.712)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Derek Zachary
            </tspan>
          </text>
          <text
            id="Ravi_Chundru"
            data-name="Ravi Chundru"
            transform="translate(19.079 183.866)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Ravi Chundru
            </tspan>
          </text>
          <text
            id="Antony_Alex"
            data-name="Antony Alex"
            transform="translate(19.079 218.261)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Antony Alex
            </tspan>
          </text>
          <text
            id="Smriti_Hazarika"
            data-name="Smriti Hazarika"
            transform="translate(19.079 255.41)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Smriti Hazarika
            </tspan>
          </text>
          <rect
            id="Rectangle_20373"
            data-name="Rectangle 20373"
            width="105.433"
            height="20.333"
            transform="translate(92.882 67.927)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20354"
            data-name="Rectangle 20354"
            width="45.185"
            height="20.333"
            transform="translate(524.402 243.397)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20356"
            data-name="Rectangle 20356"
            width="308.014"
            height="20.333"
            transform="translate(92.882 208.002)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20367"
            data-name="Rectangle 20367"
            width="67.025"
            height="20.333"
            transform="translate(261.95 102.946)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20357"
            data-name="Rectangle 20357"
            width="49.704"
            height="20.333"
            transform="translate(522.143 137.965)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20374"
            data-name="Rectangle 20374"
            width="106.939"
            height="20.333"
            transform="translate(198.314 67.927)"
            fill="#dcc882"
          />
          <rect
            id="Rectangle_20358"
            data-name="Rectangle 20358"
            width="168.692"
            height="20.333"
            transform="translate(400.896 208.002)"
            fill="#dcc882"
          />
          <rect
            id="Rectangle_20368"
            data-name="Rectangle 20368"
            width="45.939"
            height="20.333"
            transform="translate(216.012 102.946)"
            fill="#dcc882"
          />
          <rect
            id="Rectangle_20359"
            data-name="Rectangle 20359"
            width="170.952"
            height="20.333"
            transform="translate(92.882 137.965)"
            fill="#dcc882"
          />
          <rect
            id="Rectangle_20375"
            data-name="Rectangle 20375"
            width="54.976"
            height="20.333"
            transform="translate(305.253 67.927)"
            fill="#8ba3bc"
          />
          <rect
            id="Rectangle_20369"
            data-name="Rectangle 20369"
            width="154.384"
            height="20.333"
            transform="translate(415.581 102.946)"
            fill="#8ba3bc"
          />
          <rect
            id="Rectangle_20360"
            data-name="Rectangle 20360"
            width="228.939"
            height="20.333"
            transform="translate(92.882 243.397)"
            fill="#8ba3bc"
          />
          <rect
            id="Rectangle_20361"
            data-name="Rectangle 20361"
            width="15.815"
            height="20.333"
            transform="translate(556.032 173.36)"
            fill="#8ba3bc"
          />
          <rect
            id="Rectangle_20376"
            data-name="Rectangle 20376"
            width="125.013"
            height="20.333"
            transform="translate(360.229 67.927)"
            fill="#e76f51"
          />
          <rect
            id="Rectangle_20370"
            data-name="Rectangle 20370"
            width="125.013"
            height="20.333"
            transform="translate(92.882 102.946)"
            fill="#e76f51"
          />
          <rect
            id="Rectangle_20362"
            data-name="Rectangle 20362"
            width="258.31"
            height="20.333"
            transform="translate(263.833 137.965)"
            fill="#e76f51"
          />
          <rect
            id="Rectangle_20363"
            data-name="Rectangle 20363"
            width="258.31"
            height="20.333"
            transform="translate(297.722 173.36)"
            fill="#e76f51"
          />
          <rect
            id="Rectangle_20377"
            data-name="Rectangle 20377"
            width="85.099"
            height="20.333"
            transform="translate(485.242 67.927)"
            fill="#9c9494"
          />
          <rect
            id="Rectangle_20364"
            data-name="Rectangle 20364"
            width="204.841"
            height="20.333"
            transform="translate(92.882 173.36)"
            fill="#9c9494"
          />
          <rect
            id="Rectangle_20355"
            data-name="Rectangle 20355"
            width="204.841"
            height="20.333"
            transform="translate(319.562 243.397)"
            fill="#9c9494"
          />
          <rect
            id="Rectangle_20371"
            data-name="Rectangle 20371"
            width="88.112"
            height="20.333"
            transform="translate(328.975 102.946)"
            fill="#9c9494"
          />
          <path
            id="Path_64749"
            data-name="Path 64749"
            d="M0,0H9.093V8.439H0Z"
            transform="translate(208.321 289.336)"
            fill="#9c9494"
          />
          <rect
            id="Rectangle_20372"
            data-name="Rectangle 20372"
            width="9.093"
            height="8.439"
            transform="translate(134.519 289.336)"
            fill="#dcc882"
          />
          <rect
            id="Rectangle_20365"
            data-name="Rectangle 20365"
            width="9.093"
            height="8.439"
            transform="translate(270.827 289.336)"
            fill="#e76f51"
          />
          <rect
            id="Rectangle_20366"
            data-name="Rectangle 20366"
            width="9.093"
            height="8.439"
            transform="translate(337.852 289.336)"
            fill="#8ba3bc"
          />
          <path
            id="Path_64748"
            data-name="Path 64748"
            d="M0,0H9.093V8.439H0Z"
            transform="translate(404.124 289.336)"
            fill="#9fbb7d"
          />
          <text
            id="Associated"
            transform="translate(148.074 296.83)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Associated
            </tspan>
          </text>
          <text
            id="Pending"
            transform="translate(222.63 296.83)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Pending
            </tspan>
          </text>
          <text
            id="Assigned"
            transform="translate(285.136 296.83)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Assigned
            </tspan>
          </text>
          <text
            id="Rejected_"
            data-name="Rejected "
            transform="translate(352.161 295.83)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Rejected{' '}
            </tspan>
          </text>
          <text
            id="Consent_Await"
            data-name="Consent Await"
            transform="translate(418.433 295.83)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Consent Await
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};
